import { render } from "./BlFormFieldNumber.vue?vue&type=template&id=2381b9b6"
import script from "./BlFormFieldNumber.vue?vue&type=script&lang=js"
export * from "./BlFormFieldNumber.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__